/**
 * Iter 143b · Indicador de firmas pendientes en topbar.
 *
 * Muestra un badge rojo con el nº total de:
 *   - Visados doble pendientes (presupuestos / facturas) firmables por el user.
 *   - Paquetes legales sin contrato/acta firmados.
 *
 * Usa /api/me/pendientes-firma y refresca cada 60 s.
 */
import { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import { ClipboardSignature } from "lucide-react";
import api from "@/lib/api";

export default function PendientesFirmaIndicator() {
  const [data, setData] = useState({ total: 0, visados_pendientes: 0, paquetes_pendientes: 0 });

  const load = useCallback(async () => {
    try {
      const { data: d } = await api.get("/me/pendientes-firma");
      setData(d || { total: 0 });
    } catch (_) { /* silent */ }
  }, []);

  useEffect(() => {
    load();
    const t = setInterval(load, 60_000);
    return () => clearInterval(t);
  }, [load]);

  const tip = data.total
    ? `${data.visados_pendientes} visado(s) + ${data.paquetes_pendientes} paquete(s) pendientes de firma`
    : "Sin firmas pendientes";

  return (
    <Link
      to="/admin?tab=usuarios"
      title={tip}
      data-testid="pendientes-firma-indicator"
      className="relative inline-flex items-center justify-center h-9 w-9 rounded-full hover:bg-black/[0.05] dark:hover:bg-white/[0.06] text-[var(--legatum-text-muted)] hover:text-[var(--legatum-text)] transition-colors"
    >
      <ClipboardSignature className="h-4 w-4" />
      {data.total > 0 && (
        <span
          className="absolute -top-0.5 -right-0.5 min-w-[16px] h-4 px-1 rounded-full text-[9px] font-bold flex items-center justify-center"
          style={{ background: "#DC2626", color: "#fff" }}
          data-testid="pendientes-firma-badge"
        >
          {data.total > 99 ? "99+" : data.total}
        </span>
      )}
    </Link>
  );
}
